import { Link2, Compass, ChevronLeft, Tag, BarChart, Users, Filter, Upload } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { DropdownNavItem } from './DropdownNavItem'

const FolderIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <rect x="7" y="7" width="10" height="10" rx="1" ry="1" />
  </svg>
);

interface SidebarProps {
  className?: string
}

export function Sidebar({ className }: SidebarProps) {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [linksExpanded, setLinksExpanded] = useState(false)
  const [discoverExpanded, setDiscoverExpanded] = useState(false)

  return (
    <div 
      className={cn(
        "relative bg-gray-50 dark:bg-gray-800/50 border-r border-gray-200 dark:border-gray-700 transition-[width] duration-300 ease-in-out h-full flex flex-col",
        isCollapsed ? "w-20" : "w-60",
        className
      )}
    >
      {/* Toggle button */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground absolute -right-3 top-16 z-50 h-6 w-6 rounded-full border bg-background dark:bg-card shadow-md"
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <ChevronLeft className={cn(
          "h-4 w-4 transition-transform duration-300",
          isCollapsed ? "rotate-180" : ""
        )} />
      </button>

      <div className="flex-1 flex flex-col gap-4 px-4 mt-16 overflow-y-auto">
        {/* Main Navigation */}
        <nav className="flex flex-col gap-1">
          <DropdownNavItem 
            icon={<Link2 />} 
            label="Links" 
            isCollapsed={isCollapsed}
            isExpanded={linksExpanded}
            onClick={() => setLinksExpanded(!linksExpanded)}
            mainHref="/links"
            subItems={[
              { icon: <FolderIcon size={18} />, label: "Collections", href: "/links/collections" },
              { icon: <Tag size={18} />, label: "Tags", href: "/links/tags" },
              { icon: <Filter size={18} />, label: "Filters", href: "/links/filters" },
              { icon: <Upload size={18} />, label: "Import", href: "/links/import" },
            ]}
          />
          <DropdownNavItem 
            icon={<Compass />} 
            label="Discover" 
            isCollapsed={isCollapsed}
            isExpanded={discoverExpanded}
            onClick={() => setDiscoverExpanded(!discoverExpanded)}
            subItems={[
              { icon: <BarChart size={18} />, label: "Mine", href: "/discover/mine" },
              { icon: <Users size={18} />, label: "Network", href: "/discover/network-activity" },
            ]}
          />
        </nav>
      </div>
      
      <div className={cn(
        "p-4 border-t border-gray-200 dark:border-gray-700 flex mt-auto",
        isCollapsed ? "justify-center" : "justify-between items-center"
      )}>
      </div>
    </div>
  )
}

export default Sidebar